module.exports = __webpack_public_path__ + "static/riba-koja-nije-umjela-plakati-32bb2a218413cfe3af623869b7ecba7c.png";